import { alpha } from '@mui/material/styles';
import { portfolioButtonStyles } from '../../../styles';

/**
 * Styles for LoginToContinueModal — the dialog shown when an unauthenticated
 * user clicks "Purchase Now" on a product card.
 */
const styles = theme => ({
    // Spread shared button styles (primaryButton, secondaryButton, tertiaryButton, importantButton)
    ...portfolioButtonStyles(theme),
    // Dialog container — rounded corners with inner padding
    dialogPaper: {
        borderRadius: '12px',
        padding: theme.spacing(2),
    },
    // Top row: "Login to Continue" title on the left, close (X) button on the right
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: theme.spacing(1),
    },
    // Bold modal title text
    title: {
        fontWeight: 600,
        fontSize: '1rem',
        color: theme.palette.text.dark,
    },
    // Info banner with lightbulb icon — "Sign in to easily track your policy and claims later."
    infoBox: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(1.25, 1.5),
        borderRadius: '8px',
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
        border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
        color: theme.palette.primary.main,
        fontSize: '0.85rem',
    },
    // Label above each form field (username / password) — currently commented out in the component
    sectionLabel: {
        fontWeight: 600,
        fontSize: '0.85rem',
        color: theme.palette.primary.main,
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(0.5),
    },
    // Spacing for inline form input fields — currently commented out in the component
    formField: {
        marginBottom: theme.spacing(1.5),
    },
    // Full-width Login button style
    loginButton: {
        width: '100%',
        marginTop: theme.spacing(0.5),
    },
    // Horizontal divider with "or" text between Login and Create Account sections
    dividerRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1.5),
        color: theme.palette.text.label,
    },
    // "New here? Create an account" helper text centered above the create account button
    helperText: {
        fontSize: '0.85rem',
        color: theme.palette.text.label,
        textAlign: 'center',
    },
    // Full-width Create Account button style
    createAccountButton: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    // "Continue as Guest" link-style button at the bottom of the modal
    continueGuestButton: {
        textTransform: 'none',
        marginTop: theme.spacing(1.5),
    },
});

export default styles;
